import logo from './logo.svg';
import './App.css';
import AppRouter from './AppRouter/AppRouter';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@coreui/coreui/dist/css/coreui.min.css'

function App() {
  return (
 <>
  <AppRouter />
 </>
  );
}

export default App;
